module.exports = __webpack_public_path__ + "img/ic_launcher.f0a5b5ab.png";